module.exports = __webpack_public_path__ + "img/search.454f7fd0.svg";